import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './styles.scss';
import AppLayout from 'shared/AppLayout';
import useUserQueries from 'hooks/query/useUserQueries';
import { useAuth } from 'core/contexts/authContext';
import Loader from 'shared/components/Loader';

const ScoreboardPage = () => {
  const navigate = useNavigate();
  const { userTeam } = useAuth();

  const { useGetScoreboardTeamsQuery } = useUserQueries();
  const getScoreboardTeamsQuery = useGetScoreboardTeamsQuery();
  const teamsData = getScoreboardTeamsQuery.data ?? [];

  const onClickGoBack = () => {
    navigate('/portal');
  };

  return (
    <AppLayout
      className="scoreboard-page"
      showScoreboard={false}
      navButtonComponent={
        <div className="header-btn-container">
          <button className="header-btn" onClick={onClickGoBack}>
            <ArrowLeft size={16} />
            MY TEAM'S PROGRESS
          </button>
        </div>
      }
    >
      {getScoreboardTeamsQuery.isLoading ? (
        <div className="scoreboard-loader-container">
          <Loader size={40} />
        </div>
      ) : (
        <div className="main-content-scoreboard">
          <section>
            <div className="scoreboard-header">
              {/* "userTeam?.location_name" is used here because the user only receives teams by his location */}
              <h1 className="scoreboard-title">{userTeam?.location_name}</h1>
            </div>

            <div className="scoreboard-table-container">
              <table className="scoreboard-table">
                <thead>
                  <tr>
                    <th>TEAM NAME</th>
                    <th># OF TEAMMATES</th>
                    <th>SESSION TOTAL</th>
                    <th>SESSION GOAL</th>
                  </tr>
                </thead>
                <tbody>
                  {teamsData.map((team, index) => (
                    <tr key={index}>
                      <td>{team.team_name}</td>
                      <td className="centered-cell">{team.team_size}</td>
                      <td className="centered-cell">{team.session_total}</td>
                      <td className="centered-cell">{team.session_goal}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      )}
    </AppLayout>
  );
};

export default ScoreboardPage;
